import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Signin.scss';
import '../Loader.scss';
import axios from 'axios';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import wa_icon from '../../assets/icons/Whatsapp-icon.svg';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthProvider';

function Signin() {
    const { user, setUser } = useAuth();

    const [step, setStep] = useState("phone");
    const [isAwaitingResponse, setAwaitingResponse] = useState(false);
    const [userPhoneNumber, setPhone] = useState('');
    const [userCode, setCode] = useState('');

    const phoneInput = useRef(null);
    const codeInput = useRef(null);

    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            navigate('/user/dashboard/');
        }
    }, [user, navigate]);

    const api = process.env.REACT_APP_API_URL;

    const formatPhoneNumber = (phoneNumber) => {
        let result = phoneNumber.replace("+","");
        return result;
    }

    const requestCode = async (event) => {
        event.preventDefault();
        setAwaitingResponse(true);

        if(userPhoneNumber === undefined || !isValidPhoneNumber(userPhoneNumber)){
            toast.error("Invalid phone number. Please make sure you've entered your data correctly and try again.");
            setAwaitingResponse(false);
            return;
        }

        event.target.disabled = true;
        phoneInput.current.disabled = true;

        const data = {
            user_phone: formatPhoneNumber(userPhoneNumber)
        }

        axios.post(`${api}/authorization/signin/request`, data)
            .then((response) => {
                const resStatus = response.data.status;
                setStep(resStatus);
                if(resStatus === 'awaiting'){
                    toast.success("Your single-use password is on it's way! Open your WhatsApp app.");
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                toast.error("Network error. Please try again.");
                phoneInput.current.disabled = false;
            })
            .finally(() => {
                setAwaitingResponse(false);
                event.target.disabled = false;
            });
    }

    const confirmCode = async (event) => {
        event.preventDefault();
        event.target.disabled = true;
        codeInput.current.disabled = true;
        setAwaitingResponse(true);

        const data = {
            user_phone: formatPhoneNumber(userPhoneNumber),
            verification_code: userCode
        }

        axios.post(`${api}/authorization/signin/confirm`, data)
            .then((response) => {
                const resStatus = response.data.status;
                setStep(resStatus);
                if(resStatus === "invalid_code") return;
                setUser(response.data.user_phone);
                localStorage.setItem('auth_token', response.data.auth_token);
                toast.success("SignIn was successful!");
                navigate('/user/dashboard/');
            })
            .catch((error) => {
                console.error("Error:", error);
                toast.error("Network error. Please try again.");
            })
            .finally(() => {
                setAwaitingResponse(false);
                event.target.disabled = false;
                codeInput.current.disabled = false;
            });
    }

    const handleCodeChange = (e) => {
        setCode(e.target.value);
    }

    return (
        <>
        <div className='background wrapper reg'></div>
        <div className='registration signin form'>
            <header>
                <h3 className='title'>Sign In</h3>
            </header>
            <main>
                {step === "phone" ? 
                (
                    <form className='inputs' onSubmit={requestCode}>
                        <div className="phone input-group icon gap">
                            <img alt=""  className='icon' src={wa_icon}/>
                            <PhoneInput
                                ref={phoneInput}
                                placeholder="Enter phone number"
                                value={userPhoneNumber}
                                onChange={setPhone}
                                id="userPhoneNumber"/>
                        </div>
                        <button className='btn primary submit'>Submit</button>
                    </form>
                )
                : 
                (
                    <form className='inputs' onSubmit={confirmCode}>
                        <div className="confirmation input-group multiple gap">
                            <label htmlFor="userConfirmation">Confirmation Code:</label>
                            <div className='input-group icon gap'>
                                <img alt=""  className='icon' src={wa_icon}/>
                                <input 
                                    type="text" 
                                    className='input'
                                    ref={codeInput} 
                                    name="userConfirmation" 
                                    id="userConfirmation" 
                                    placeholder='000000' 
                                    value={userCode} 
                                    onChange={handleCodeChange} 
                                    autoComplete='off'
                                />
                            </div>
                        </div>
                        <button className='btn primary submit'>Submit</button>
                    </form>
                ) 
                }
            </main>
            {
                isAwaitingResponse ? (
                    <div className='loader bg'>
                        <div className='loader spinner'></div>
                    </div>
                ) : <></>
            }
        </div>
        </>
    )
}

export default Signin